<template>
	<div class="planning-legend-panel">
		<p class="small text-muted mb-2">
			How the Planning map draws evidence and work demand.
		</p>
		<div class="legend-row">
			<span class="legend-dot" style="background: #198754"></span>Signal ·
			promotive
		</div>
		<div class="legend-row">
			<span class="legend-dot" style="background: #dc3545"></span>Signal ·
			suppressive
		</div>
		<div class="legend-row">
			<span class="legend-dot" style="background: #6c757d"></span>Signal ·
			contextual
		</div>
		<div class="legend-row">
			<span class="legend-dot legend-dot--hollow"></span>Signal · unreviewed
		</div>
		<div class="legend-row">
			<span class="legend-cell" style="background: #0d6efd55"></span>Lead · open
		</div>
		<div class="legend-row">
			<span class="legend-cell" style="background: #6c757d33"></span>Lead ·
			closed
		</div>
		<div class="legend-row">
			<span class="legend-dot" style="background: #0d6efd"></span>Lead · legacy
			Site
		</div>
		<div class="legend-row">
			<span class="legend-cell" style="background: #fd7e1433"></span>Work Order
		</div>
		<hr class="my-2" />
		<div class="legend-row">
			<span class="legend-cell legend-grid"></span>Authoring grid
		</div>
		<div class="legend-row">
			<span class="legend-cell" style="background: #0d6efd22"></span>Lead cells
			· open
		</div>
		<div class="legend-row">
			<span class="legend-cell" style="background: #6c757d22"></span>Lead cells
			· closed
		</div>
		<div class="legend-row">
			<span class="legend-cell" style="background: #ffc10788"></span>Draft cell
		</div>
		<div class="legend-row">
			<span class="legend-cell" style="background: #dc354588"></span>Overlaps an
			open Lead
		</div>
	</div>
</template>

<style scoped>
.planning-legend-panel {
	font-size: 0.75rem;
}
.legend-row {
	display: flex;
	align-items: center;
	gap: 7px;
	line-height: 1.5;
}
.legend-dot {
	width: 10px;
	height: 10px;
	border-radius: 50%;
	box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.25);
}
/* A Signal nobody has judged yet: the map draws it hollow so it cannot be read
   as the solid blue dot a legacy Lead site draws. */
.legend-dot--hollow {
	background: #fff;
	box-shadow: inset 0 0 0 2px #0d6efd;
}
.legend-cell {
	width: 12px;
	height: 10px;
	border-radius: 2px;
	box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.25);
}
/* The grid is a hairline, not a fill: its swatch is the outline alone, at the
   same weight the map draws it. */
.legend-grid {
	background: transparent;
	box-shadow: inset 0 0 0 1px #adb5bd;
}
</style>
